export default __webpack_public_path__ + "static/broadcastImg5-90586f1155661e61a23be6681a32e2d7.webp";